import { render, staticRenderFns } from "./ego.vue?vue&type=template&id=66afd181"
import script from "./ego.vue?vue&type=script&lang=js"
export * from "./ego.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports